import moment from "moment";
import { app } from "../services";

const TENANT_SERVICES = new Set([
  "clients",
  "client-users",
  "client-groups",
  "products",
  "product-variants",
  "product-assignments",
  "product-processes",
  "fields",
  "process-fields",
  "field-values",
  "clientes-data",
  "documents",
  "catalogs",
  "catalog-items",
  "banks",
  "credit-reports",
]);

const getTenantIdFromStorage = () => {
  try {
    const persisted = localStorage.getItem("persist:root");
    if (!persisted) return null;
    const root = JSON.parse(persisted);
    const sessionRaw = root?.session;
    if (!sessionRaw) return null;
    const session = JSON.parse(sessionRaw);
    return session?.institution?.id || null;
  } catch (error) {
    return null;
  }
};

const initCatalogs = async function (catalog, callback) {
  // lastUpdate puede venir como string/Date/moment.
  // Aseguramos Date válida para Sequelize/MySQL (DATETIME)
  const since = catalog?.lastUpdate
    ? new Date(catalog.lastUpdate) // ✅ Date, NO getTime()
    : new Date("1970-01-01T00:00:00.000Z");

  const tenantId = getTenantIdFromStorage();
  const requiresTenant = TENANT_SERVICES.has(catalog?.service);
  const query = {
    $limit: 20000,
    $sort: { updatedAt: 1 }, // opcional pero recomendable
    updatedAt: {
      $gt: since, // ✅ Date
    },
    ...(requiresTenant && tenantId ? { id_institucion: tenantId } : {}),
  };

  try {
    const response = await app.service(catalog.service).find({
      query,
    });

    callback({
      ...catalog,
      lastUpdate: moment().toISOString(), // ✅ guarda como ISO para consistencia
      data: response.data || [],
    });
  } catch (error) {
    const message = `${error?.message || ""}`;
    const isTenantError = message.includes("Tenant requerido");
    const isSchemaError =
      message.includes("Unknown column") ||
      message.includes("field list");

    if (isTenantError || isSchemaError) {
      console.warn(
        `[catalogs] omitido '${catalog?.service}' por error controlado:`,
        message
      );
      callback({
        ...catalog,
        data: catalog?.data || [],
      });
      return;
    }

    throw error;
  }
};

const common = { initCatalogs };
export default common;
